/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeKoffermaticPerfIngestDto,
  ApiEnvelopeModJarInfoDto,
  ProblemDetails
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type koffermaticInfoResponse200 = {
  data: ApiEnvelopeModJarInfoDto
  status: 200
}

export type koffermaticInfoResponseSuccess = (koffermaticInfoResponse200) & {
  headers: Headers;
};
;

export type koffermaticInfoResponse = (koffermaticInfoResponseSuccess)

export const getKoffermaticInfoUrl = () => {




  return `/api/koffermatic/info`
}

export const useKoffermaticInfoHook = (): ( options?: RequestInit) => Promise<koffermaticInfoResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getKoffermaticInfoUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type koffermaticDownloadResponse200 = {
  data: Blob
  status: 200
}

export type koffermaticDownloadResponse404 = {
  data: ProblemDetails
  status: 404
}

export type koffermaticDownloadResponseSuccess = (koffermaticDownloadResponse200) & {
  headers: Headers;
};
export type koffermaticDownloadResponseError = (koffermaticDownloadResponse404) & {
  headers: Headers;
};

export type koffermaticDownloadResponse = (koffermaticDownloadResponseSuccess | koffermaticDownloadResponseError)

export const getKoffermaticDownloadUrl = () => {




  return `/api/koffermatic/download`
}

export const useKoffermaticDownloadHook = (): ( options?: RequestInit) => Promise<koffermaticDownloadResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getKoffermaticDownloadUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type koffermaticPerformanceResponse200 = {
  data: ApiEnvelopeKoffermaticPerfIngestDto
  status: 200
}

export type koffermaticPerformanceResponse400 = {
  data: ApiEnvelopeKoffermaticPerfIngestDto
  status: 400
}

export type koffermaticPerformanceResponseSuccess = (koffermaticPerformanceResponse200) & {
  headers: Headers;
};
export type koffermaticPerformanceResponseError = (koffermaticPerformanceResponse400) & {
  headers: Headers;
};

export type koffermaticPerformanceResponse = (koffermaticPerformanceResponseSuccess | koffermaticPerformanceResponseError)

export const getKoffermaticPerformanceUrl = () => {




  return `/api/koffermatic/performance`
}

export const useKoffermaticPerformanceHook = (): ( options?: RequestInit) => Promise<koffermaticPerformanceResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getKoffermaticPerformanceUrl(),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


